import angular from 'angular'

import component from './app-message.component'

let module = angular.module('appMessageModule', [])

.component('appMessage', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/common/app-message/index.js